// extracted by mini-css-extract-plugin
module.exports = {"appContainer":"app-container_appContainer__2znF8"};